import React, { useEffect, useState } from "react";
import { api } from "@/lib/http";
import { fmtDate } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { PackageCheck } from "lucide-react";
import { toast } from "sonner";

// Booking popup: "Package available" → USE PACKAGE SESSION (reserves it; checkout bills $0 and records the redemption).
export const PackagePrompt = ({ booking, onChanged }) => {
  const [eligible, setEligible] = useState([]);
  useEffect(() => {
    if (!booking?.client_id || booking.paid) { setEligible([]); return; }
    api.get(`/clients/${booking.client_id}/package-eligibility`, { params: { service_id: booking.service_id } }).then(({ data }) => setEligible(data.packages || [])).catch(() => setEligible([]));
  }, [booking?.id, booking?.client_id, booking?.service_id, booking?.paid, booking?.package_id]);
  if (booking.paid) return null;
  if (booking.package_id) {
    return (
      <div className="flex items-center justify-between gap-2 rounded-lg border border-emerald-300 bg-emerald-50 px-3 py-2 text-sm" data-testid="detail-package-reserved">
        <span className="text-emerald-900 flex items-center gap-1.5"><PackageCheck className="h-4 w-4" /><span><span className="font-semibold">Package session</span> · {booking.package_name || "reserved"} — no charge at checkout</span></span>
        {!booking.package_redeemed && <button className="text-xs text-muted-foreground hover:underline" onClick={async () => { await api.delete(`/bookings/${booking.id}/use-package`); onChanged?.({ package_id: null, package_name: null }); }} data-testid="detail-package-clear">don't use</button>}
      </div>
    );
  }
  if (!eligible.length) return null;
  return (
    <div className="rounded-lg border border-primary/30 bg-primary/5 px-3 py-2 text-sm space-y-1.5" data-testid="detail-package-available">
      <div className="font-semibold text-primary flex items-center gap-1.5"><PackageCheck className="h-4 w-4" />Package available</div>
      {eligible.map((p) => (
        <div key={p.id} className="flex items-center justify-between gap-2">
          <span className="min-w-0"><span className="block truncate">{p.name}</span><span className="block text-[11px] text-muted-foreground">{p.sessions_remaining} session{p.sessions_remaining === 1 ? "" : "s"} remaining{p.expires_at ? ` · expires ${fmtDate(p.expires_at)}` : ""}</span></span>
          <Button size="sm" className="rounded-lg shrink-0" onClick={async () => {
            try { const { data } = await api.post(`/bookings/${booking.id}/use-package`, { package_id: p.id }); toast.success("Package session reserved for this visit"); onChanged?.({ package_id: data.package_id, package_name: data.package_name }); }
            catch (e) { toast.error(e?.response?.data?.detail || "Couldn't use package"); }
          }} data-testid={`use-package-${p.id}`}>Use package session</Button>
        </div>
      ))}
    </div>
  );
};
